export const CajaFields = (data, origen) => {
  return [
    {
      label: 'Origen',
      class: 'textfield',
      value: origen,
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Sucursal',
      class: 'textfield',
      value: data.sucursal,
      sm: 3,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Punto de venta',
      class: 'textfield',
      value: data.punto_venta,
      sm: 3,
      xs: 12,
      disabled: true,
    },
  ]
}
